import { ICreator } from "../../../../../types/models/creator.models.types";
import { usePostHttp } from "../../../http.hook";

export interface IPostKycActionResponse {
  creator: ICreator;
}

interface IBody {
  message: string;
}

export function useRejectGstAdminHttp() {
  return usePostHttp<IBody, IPostKycActionResponse>({
    path: "/admin/kyc/creator/:creatorId/gst/reject",
  });
}
